// @flow
import React from 'react'
import Helmet from 'react-helmet'
import styled from 'styled-components'
import colors from '../../styles/colors'
import media from '../../styles/media'
import WelcomeContent from '../../components/WelcomeContent'

const Header = styled.header`
  background: #e9eeed;
  padding: 2rem 0;
`

const Lead = styled.h6`
  color: ${colors.primary};
  text-transform: uppercase;
  font-weight: 300;
`

const Company = styled.h1`
  font-weight: 300;
  position: relative;
  margin-bottom: 2rem;
  font-size: inherit;

  ${media.smUp} {
    font-size: 50px;
  }

  &::after {
    position: absolute;
    bottom: -1rem;
    left: 0;
    height: 2px;
    width: 50px;
    background: ${colors.primary};
    content: '';
  }
`

const Welcome = () => (
  <div>
    <Helmet title="Welcome" />
    <Header>
      <div className="container">
        <Lead>Welcome</Lead>
        <Company>Kief Realty</Company>
        <p>
          We sell real estate, but that doesn&apos;t mean that we&apos;re
          boring. Please join our VIP contact group to help support our business
          and stay connected with us. And then BAM... you&apos;re automatically
          entered for a chance to win a FREE iPad. How do you like that Apple?
          Get it? Check out the video below for more details!
        </p>
      </div>
    </Header>
    <div style={{ background: '#fff' }}>
      <div className="container">
        <div style={{ padding: '4rem 0' }}>
          <WelcomeContent />
        </div>
      </div>
    </div>
  </div>
)

export default Welcome



// WEBPACK FOOTER //
// ./src/views/Welcome/index.js